// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import VerticalAlignTopOutlinedSvg from "@fishx/icons-svg/es/asn/VerticalAlignTopOutlined";
import FishxIcon from '../components/FishxIcon';

var VerticalAlignTopOutlined = function VerticalAlignTopOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: VerticalAlignTopOutlinedSvg
  }));
};

VerticalAlignTopOutlined.displayName = 'VerticalAlignTopOutlined';
export default React.forwardRef(VerticalAlignTopOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/VerticalAlignTopOutlined.js
// module id = 4368
// module chunks = 0